/* eslint-disable */
import React from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { AiOutlineArrowLeft } from 'react-icons/ai'

function BuildAnAtom() {
  const navigate = useNavigate()
  const [searchParams, setSearchParams] = useSearchParams()
  
  // Support ?lang=fr or ?lang=en query parameter, default to 'en'
  const language = searchParams.get('lang') === 'fr' ? 'fr' : 'en'
  
  // Check for embed mode - hides all UI chrome
  const isEmbedMode = searchParams.get('embed') === 'true'
  
  const src = `/openstax/build-an-atom/build-an-atom_${language}.html`
  
  const toggleLanguage = () => {
    const newLang = language === 'en' ? 'fr' : 'en'
    // Preserve embed parameter when switching language
    const newParams = { lang: newLang }
    if (isEmbedMode) newParams.embed = 'true'
    setSearchParams(newParams)
  }

  return (
    <div className="fixed inset-0 w-full h-full overflow-hidden">
      {/* Hide UI chrome in embed mode */}
      {!isEmbedMode && (
        <>
          <AiOutlineArrowLeft
            className="fixed z-50 m-2 top-0 left-0 text-3xl text-gray-900 transition-colors hover:cursor-pointer dark:text-gray-100"
            onClick={() => {
              navigate('/')
            }}
          />
          
          {/* Language switcher */}
          <button
            onClick={toggleLanguage}
            className="fixed z-50 top-2 right-2 px-3 py-2 rounded-full transition-colors text-sm font-medium bg-white/80 hover:bg-white text-gray-800 shadow-md"
            title={language === 'en' ? 'Passer au français' : 'Switch to English'}
          >
            {language === 'en' ? 'FR' : 'EN'}
          </button>
        </>
      )}
      
      {/* Iframe - fullscreen in embed mode, with margins otherwise */}
      <div className={`absolute inset-0 ${isEmbedMode ? '' : 'md:inset-x-[8.333%]'} overflow-hidden`}>
        <iframe 
          key={language}
          title={`Build an Atom (${language === 'en' ? 'English' : 'Français'})`}
          src={src} 
          scrolling="no"
          className="w-full h-full border-0 bg-black" 
          style={{ display: 'block', margin: 0, padding: 0, overflow: 'hidden' }} 
        />
      </div>
    </div>
  )
}

export default BuildAnAtom
